


(function ($) { // Hide scope, no $ conflict
    'use strict';
    var pluginName = 'searchboxPicker';
    var typingTimer;                //timer identifier
    var doneTypingInterval = 800;
    var chekedTimeRequest = true;
    window.searchboxTimer = null;
    window.searchboxLock = null;              //timer identifier
    //time in ms (5 seconds)
    $.JQPlugin.createPlugin({

        name: pluginName,

        defaultRenderer: {
            picker: '<div class="component-searchbox {x.pickerClass}">{content}{link:clear}<div class="clear-fix"></div></div>', //{link:close}
            inputBlock: '<div class="searchbox searchbox-input__wrapper"><input class="c-search-fields__input component-searchbox__input" type="text" id="searchboxInput" placeholder="{x.placeholder}" autocomplete="off" style="height: 25px;" value="{x.defaultvaluetext}"/></div>',
            emptyBlock: '<div class="searchbox-empty"></div>',
            resultBlock: '<ul class="searchbox searchbox-result"></ul>',
            resultBlockItem: '<li class="searchbox-item" data-id="{x.id}" data-city-code="{x.cityCode}" data-shortdesc="{x.shortDesc}" data-longdesc="{x.longDesc}" data-text="{x.text}" data-value="{x.value}" data-comma="{x.comma}"><i class="{x.icon}"></i><span class="component-searchbox__city">{x.text}</span><span>{x.comma}</span><span class="component-searchbox__shortdesc">{x.shortDesc}</span><div class="component-searchbox__longDesc">{x.longDesc}</div></li>',
            resultBlockItemLink: '<li class="searchbox-item" data-id="{x.id}" data-city-code="{x.cityCode}" data-shortdesc="{x.shortDesc}" data-longdesc="{x.longDesc}" data-text="{x.text}" data-value="{x.value}" data-comma="{x.comma}"><a href="{x.url}"><i class="{x.icon}"></i><span class="component-searchbox__city">{x.text}</span><span>{x.comma}</span><span class="component-searchbox__shortdesc">{x.shortDesc}</span><div class="component-searchbox__longDesc">{x.longDesc}</div></a></li>',
            rtlClass: 'searchbox-rtl',
            commandClass: 'searchbox-cmd',
            commandButtonClass: '',
            commandLinkClass: '',
            disabledClass: 'searchbox-disabled'
        },

        commands: {
            clear: {
                text: 'clearText',
                status: 'clearStatus', // Clear
                keystroke: { keyCode: 8, ctrlKey: true }, // Ctrl + Backspace
                enabled: function () { return true; },
                date: function () { return null; },
                action: function () {
                    plugin.clear(this);
                }
            },
            close: {
                text: 'closeText',
                status: 'closeStatus', // Close
                keystroke: { keyCode: 27 }, // Escape
                enabled: function () { return true; },
                date: function () { return null; },
                action: function (inst, obj) {
                    plugin.hide(this, obj);
                }
            },
            search: {
                text: 'searchText',
                status: 'searchStatus', // Search
                keystroke: { keyCode: 13 }, // Enter
                enabled: function () { return true; },
                date: function () { return null; },
                action: function (inst, obj) {
                    plugin.search(this, obj);
                }
            }

        },

        defaultOptions: {
            inputPlaceHolder: '',
            sourceUrl: '',
            pickerClass: '',
            emptyTitle: '',
            minLength: 0,
            maxItem: 30,
            currentItem: -1,
            delay: 8,
            showOnFocus: true,
            showTrigger: null,
            showAnim: 'show', //show
            showOptions: {},
            showSpeed: 'normal',
            popupContainer: null,
            alignment: 'bottom',
            calculateWeek: null,
            localNumbers: false,
            useMouseWheel: true,
            onInit: null,
            onShow: null,
            onBeforeShow: null,
            onAfterShow: null,
            onSelect: null,
            onClose: null,
            onClear: null,
            onHide: null,
            onSwapperClick: null,
            altField: null,
            altFormat: null,
            defaultCulture: 'fa-IR',
            firstEmptyDataForLoadAjax: '+++',
            secondEmptyDataForLoadAjax: '***',
            constrainInput: true,
            manualClose: false,
            commands: {}, // this.commands,
            device: "desktop",
            storageKey: '',
            swapperSelector: '',
            swapperTargetSelector: '',
            defaultValueText: '',
            generateHyperLinks: false
        },

        regionalOptions: { // Available regional settings, indexed by language/country code
            '': { // Default regional settings - English/US
                renderer: {}, // this.defaultRenderer
                clearText: 'پاک کردن ',
                clearStatus: 'پاک کردن',
                closeText: 'بستن ',
                closeStatus: 'بستن',
                searchText: 'جستجو ',
                searchStatus: 'جستجو',
                isRTL: false
            }
        },

        _disabled: [],
        _xhr: null,

        _popupClass: 'searchbox-popup', // Marker for popup division
        _triggerClass: 'searchbox-trigger', // Marker for trigger element
        _disableClass: 'searchbox-disable', // Marker for disabled element

        _init: function () {
            this.defaultOptions.commands = this.commands;
            this.regionalOptions[''].renderer = this.defaultRenderer;

            this._super();
        },

        _instSettings: function (elem, options) { // jshint unused:false
            elem = $(elem.target || elem);
            var inst = plugin._getInst(elem);

            if ($.isFunction(options.onInit)) {
                options.onInit.apply(elem, [inst, elem, options]);
            }


            if ($.isFunction(options.onSwapperClick)) {
                $(options.swapperSelector).on('click', function () {
                    var button = $(this);
                    options.onSwapperClick.apply(elem, [button, options]);
                });
            }

            return {
                // selectedDates: [], drawDate: null, pickingRange: false,
                inline: ($.inArray(elem[0].nodeName.toLowerCase(), ['div', 'span']) > -1),
                get: function (name) { // Get a setting value, computing if necessary
                    // if ($.inArray(name, ['defaultDate', 'minDate', 'maxDate']) > -1) { // Decode date settings
                    // 	return this.options.calendar.determineDate(this.options[name], null,
                    // 		this.selectedDates[0], this.get('dateFormat'), this.getConfig());
                    // }
                    // if (name === 'dateFormat') {
                    // 	return this.options.dateFormat || this.options.calendar.local.dateFormat;
                    // }
                    return this.options[name];
                }
            };
        },

        _saveState: function (elem, inst, item) {
            if ($.isFunction(inst.options.onSelect)) {
                inst.options.onSelect.apply(elem, [inst, elem, item]);
            }
        },

        _postAttach: function (elem, inst) {
            if (inst.inline) {
                this._update(elem[0]);
                if ($.fn.mousewheel) {
                    elem.mousewheel(this._doMouseWheel);
                }
            }
            else {
                this._attachments(elem, inst);
                elem.on('keydown.' + inst.name, this._keyDown).on('keypress.' + inst.name, this._keyPress).
                    on('keyup.' + inst.name, this._keyUp);
                if (elem.attr('disabled')) {
                    this.disable(elem[0]);
                }
            }
        },

        _optionsChanged: function (elem, inst, options) {
            //this._structure(elem, inst, options);
            $.extend(inst.options, options);

            // this.setDate(elem[0], dates, null, false, true);

            if (!inst.inline) {
                this._attachments(elem, inst);
            }
            if (inst.inline || inst.div) {
                this._update(elem[0]);
            }
        },

        _attachments: function (elem, inst) {
            elem.off('focus.' + inst.name);
            if (inst.options.showOnFocus) {
                elem.on('focus.' + inst.name, this.show);
            }
            if (inst.trigger) {
                inst.trigger.remove();
            }
            var trigger = inst.options.showTrigger;
            inst.trigger = (!trigger ? $([]) :
                $(trigger).clone().removeAttr('id').addClass(this._triggerClass)
                [inst.options.isRTL ? 'insertBefore' : 'insertAfter'](elem).
                    click(function () {
                        if (!plugin.isDisabled(elem[0])) {
                            plugin[plugin.curInst === inst ? 'hide' : 'show'](elem[0]);
                        }
                    }));
            this._autoSize(elem, inst);
        },

        _autoSize: function (elem, inst) { },

        _preDestroy: function (elem, inst) {
            if (inst.trigger) {
                inst.trigger.remove();
            }
            elem.empty().off('.' + inst.name);
            if (inst.inline && $.fn.mousewheel) {
                elem.unmousewheel();
            }
            if (!inst.inline && inst.options.autoSize) {
                elem.removeAttr('size');
            }
        },

        multipleEvents: function (fns) {
            var funcs = arguments;
            return function () {
                for (var i = 0; i < funcs.length; i++) {
                    funcs[i].apply(this, arguments);
                }
            };
        },

        enable: function (elem) {
            elem = $(elem);
            if (!elem.hasClass(this._getMarker())) {
                return;
            }
            var inst = this._getInst(elem);
            if (inst.inline) {
                elem.children('.' + this._disableClass).remove().end().
                    find('button,select').prop('disabled', false).end().
                    find('a').attr('href', '#');
            }
            else {
                elem.prop('disabled', false);
                inst.trigger.filter('button.' + this._triggerClass).prop('disabled', false).end().
                    filter('img.' + this._triggerClass).css({ opacity: '1.0', cursor: '' });
            }
            this._disabled = $.map(this._disabled,
                function (value) { return (value === elem[0] ? null : value); }); // Delete entry
        },

        disable: function (elem) {
            elem = $(elem);
            if (!elem.hasClass(this._getMarker())) {
                return;
            }
            var inst = this._getInst(elem);
            if (inst.inline) {
                var inline = elem.children(':last');
                var offset = inline.offset();
                var relOffset = { left: 0, top: 0 };
                inline.parents().each(function () {
                    if ($(this).css('position') === 'relative') {
                        relOffset = $(this).offset();
                        return false;
                    }
                });
                var zIndex = elem.css('zIndex');
                zIndex = (zIndex === 'auto' ? 0 : parseInt(zIndex, 10)) + 1;
                elem.prepend('<div class="' + this._disableClass + '" style="' +
                    'width: ' + inline.outerWidth() + 'px; height: ' + inline.outerHeight() +
                    'px; left: ' + (offset.left - relOffset.left) + 'px; top: ' +
                    (offset.top - relOffset.top) + 'px; z-index: ' + zIndex + '"></div>').
                    find('button,select').prop('disabled', true).end().
                    find('a').removeAttr('href');
            }
            else {
                elem.prop('disabled', true);
                inst.trigger.filter('button.' + this._triggerClass).prop('disabled', true).end().
                    filter('img.' + this._triggerClass).css({ opacity: '0.5', cursor: 'default' });
            }
            this._disabled = $.map(this._disabled,
                function (value) { return (value === elem[0] ? null : value); }); // Delete entry
            this._disabled.push(elem[0]);
        },

        isDisabled: function (elem) {
            return (elem && $.inArray(elem, this._disabled) > -1);
        },
        show: function (elem) {
            elem = $(elem.target || elem);
            var inst = plugin._getInst(elem);
            if (plugin.curInst === inst) {
                return;
            }
            if (plugin.curInst) {
                plugin.hide(plugin.curInst, true);
            }
            if ($.isFunction(inst.options.onBeforeShow)) {
                inst.options.onBeforeShow.apply(elem, [inst, elem]);
            }

            if (!$.isEmptyObject(inst)) {
                // Retrieve existing date(s)
                inst.lastVal = null;
                //inst.selectedDates = plugin._extractDates(inst, elem.val());
                inst.pickingRange = false;
                // inst.drawDate = plugin._checkMinMax((inst.selectedDates[0] ||
                // 	inst.get('defaultDate') || inst.options.calendar.today()).newDate(), inst);
                // inst.prevDate = inst.drawDate.newDate();
                plugin.curInst = inst;
                // Generate content
                plugin._update(elem[0], false);
                // Adjust position before showing
                //var offset = plugin._checkOffset(inst);
                //inst.div.css({left: offset.left, top: offset.top});
                // And display
                var showAnim = inst.options.showAnim;
                var showSpeed = inst.options.showSpeed;
                showSpeed = (showSpeed === 'normal' && $.ui &&
                    parseInt($.ui.version.substring(2)) >= 8 ? '_default' : showSpeed);
                if ($.effects && ($.effects[showAnim] || ($.effects.effect && $.effects.effect[showAnim]))) {
                    var data = inst.div.data(); // Update old effects data
                    for (var key in data) {
                        if (key.match(/^ec\.storage\./)) {
                            data[key] = inst._mainDiv.css(key.replace(/ec\.storage\./, ''));
                        }
                    }
                    inst.div.data(data).show(showAnim, inst.options.showOptions, showSpeed);
                }
                else {
                    inst.div[showAnim || 'show'](showAnim ? showSpeed : 0);
                }
            }

            setTimeout(function () {

                if ($(".searchbox-popup").length > 0 && isMobile()) {
                    $('body').css('overflow', 'hidden')
                }
            }, 200)


            if ($.isFunction(inst.options.onAfterShow)) {
                inst.options.onAfterShow.apply(elem, [inst, elem]);
            }
            //if (plugin._getInput(elem).val()) {
            plugin._callAjaxGetSource(elem, plugin._getInput(elem).val());
            //}
            plugin._getInput(elem).focus();

        },
        _getInput: function (elem) {
            var plugin = this;
            var inst = plugin._getInst(elem);

            return inst.div.find("input[type=text]");
        },

        _update: function (elem, hidden) {
            chekedTimeRequest = false;
            setTimeout(function () {
                chekedTimeRequest = true;
            }, 0)
            elem = $(elem.target || elem);
            var inst = plugin._getInst(elem);
            if (!$.isEmptyObject(inst)) {
                if (inst.inline || plugin.curInst === inst) {

                }
                if (inst.inline) {
                    var index = $('a, :input', elem).index($(':focus', elem));
                    elem.html(this._generateContent(elem[0], inst));
                    var focus = elem.find('a, :input');
                    focus.eq(Math.max(Math.min(index, focus.length - 1), 0)).focus();
                }
                else if (plugin.curInst === inst) {
                    if (!inst.div) {
                        inst.div = $('<div></div>').addClass(this._popupClass).
                            css({
                                display: (hidden ? 'none' : 'static'), position: 'absolute' //,
                                //left: elem.offset().left, top: elem.offset().top + elem.outerHeight()
                            }).
                            appendTo($(inst.options.popupContainer || 'body'));
                        if ($.fn.mousewheel) {
                            inst.div.mousewheel(this._doMouseWheel);
                        }
                    }
                    inst.div.html(this._generateContent(elem[0], inst));
                    elem.focus();
                }
            }
            //this.checkActive(elem);
        },

        _updateInput: function (elem, keyUp) {
            var inst = this._getInst(elem);
            if (!$.isEmptyObject(inst)) {
                var value = '';

                //for (var i = 0; i < inst.selectedDates.length; i++) {
                //	// value += (keyUp ? '' : (i > 0 ? sep : '') +
                //	// 	calendar.formatDate(dateFormat, inst.selectedDates[i], settings));
                //	// altValue += (i > 0 ? sep : '') +
                //	// 	calendar.formatDate(altFormat, inst.selectedDates[i], settings);
                //}
                if (!inst.inline && !keyUp) {
                    $(elem).val(value);
                }

                $(elem).change();
            }
        },

        _getBorders: function (elem) {
            var convert = function (value) {
                return { thin: 1, medium: 3, thick: 5 }[value] || value;
            };
            return [parseFloat(convert(elem.css('border-left-width'))),
            parseFloat(convert(elem.css('border-top-width')))];
        },

        _callAjaxGetSource: function (elem, textpart) {
            var plugin = this;
            var inst = this._getInst(elem);
            //on keyup, start the search

            if ($(".searchbox-popup").length > 0) {
                dataAjaxRequestCity()

            }


            $('.component-searchbox__input').keyup(function () {
                chekedTimeRequest = true;
                dataAjaxRequestCity();

            })



            $('#searchboxInput').keyup(function () {
                chekedTimeRequest = true;
                dataAjaxRequestCity();

            });
            function dataAjaxRequestCity() {
                clearTimeout(typingTimer);
                if ($('#searchboxInput').val) {
                    typingTimer = setTimeout(function () {
                        //do stuff here e.g ajax call etc....
                        var valueInput = $("#searchboxInput").val();
                        if (textpart.length >= inst.options.minLength) {
                            if (inst._xhr != null) {
                                inst._xhr.abort();
                            }
                            inst._xhr = $.ajax({
                                url: inst.options.sourceUrl,
                                type: 'POST',
                                cache: false,
                                timeout: 3000,
                                dataType: 'json',
                                data: { Part: valueInput },
                                success: function (result) {
                                    var maxItem = inst.options.maxItem;
                                    if (inst.div != null) {
                                        if ($(inst.div.find(".searchbox-result, .searchbox-empty")).parents("#DomesticTrainSource-container").length > 0) {
                                            maxItem = 200;
                                        }
                                        if ($(inst.div.find(".searchbox-result, .searchbox-empty")).parents("#DomesticTrainDestination-container").length > 0) {
                                            maxItem = 200;
                                        }
                                    }
                                    var data = result.length > 0 ? result.slice(0, maxItem) : [];
                                    inst.options.currentItem = -1;
                                    inst.options.data = data;
                                    if (inst.div != undefined) {
                                        var container = inst.div.find(".searchbox-result, .searchbox-empty");
                                        var parent = container.parent();
                                        container.remove();
                                        if (data.length > 0) {
                                            var resultBlock = $(inst.options.renderer.resultBlock);
                                            parent.append(resultBlock);
                                        } else {
                                            var emptyBlock =
                                                $(inst.options.renderer.emptyBlock.replace(/{x.pickerEmptyTitle}/g,
                                                    inst.options.emptyTitle));
                                            parent.append(emptyBlock);
                                        }
                                        //=====================
                                        plugin._generatePopup(elem, resultBlock, data);
                                        plugin._selectByIndex(elem, inst.div);
                                        //}
                                        if (inst.options.loadingAnimation) {
                                            //$(options.input).closest("." + options.selector.container).removeClass("loading");
                                        }
                                    }
                                    if (isMobile()) {
                                        if ($("#searchboxInput").val() != '') {
                                            $(".searchbox.searchbox-result").removeClass("d-none");
                                        }
                                        else {
                                            if ($("#search-switch-btn").hasClass("on")) {
                                                $(".searchbox.searchbox-result").removeClass("d-none");
                                            }
                                            else {
                                                $(".searchbox.searchbox-result").addClass("d-none");
                                            }
                                        }
                                    }
                                },
                                error: function (xhr, ajaxOptions, thrownError) {
                                    xhr.abort();
                                }
                            });
                        } else {
                        }
                    }, !chekedTimeRequest ? 0 : doneTypingInterval);
                }
            }

       
        },

        _notEmpty: function (obj) {
            var flag = ((typeof obj === "undefined") || (obj === null) || (obj === "") || (obj.length == 0)) ? false : true;
            return flag;
        },

        _getByIndex: function (res, index) {
            return (res.length > index) ? res[index] : null;
        },

        _getExactItem: function (res, textpart) {
            var plugin = this;
            var first = plugin._getByIndex(res, 0);
            var second = plugin._getByIndex(res, 1);
            if (plugin._notEmpty(textpart) && res.length > 0) {
                var item = res.filter(q => q.Text === textpart)[0];
                item = plugin._notEmpty(item) ? item : first;
                item = plugin._notEmpty(item) ?
                    (plugin._notEmpty(item.Value) && item.Value.toLowerCase() === 'cat' ? second : item) :
                    null;
                return item;
            }

            else {
                return null;
            }
        },

        _setValueOnMainInput: function () {
            var parent = $(_getInputParentElement());
            var text = parent.data("x-text");
            var val = parent.data("x-val");
            if (val != "") {
                _setValue(text, val);
            }
        },

        _generatePopup: function (elem, block, res) {
            var plugin = this;
            var inst = this._getInst(elem);
            //var resultBlock = inst.div.find(".searchbox-result");
            $.each(res, function (i, v) {
              
                if (inst.options.generateHyperLinks) {
                    var item = inst.options.renderer.resultBlockItemLink;
                    item = item
                        .replace(/{x.text}/g, v.Text)
                        .replace(/{x.id}/g, v.ID)
                        .replace(/{x.icon}/g, v.Icon) //"icon-location") //
                        .replace(/{x.cityCode}/g, v.CityCode)
                        .replace(/{x.value}/g, v.Value)
                        .replace(/{x.shortDesc}/g, v.ShortDescription ? v.ShortDescription.replace(/"/g, "'") : "")
                        .replace(/{x.longDesc}/g, v.LongDescription ? v.LongDescription.replace(/"/g, "'") : "")
                        .replace(/{x.url}/g, v.Url ? v.Url.replace(/"/g, "'") : "")
                        .replace(/{x.comma}/g,
                            plugin._notEmpty(v.ShortDescription) ? (v.IsPersian ? "، " : ", ") : ""
                        );

                    item = $(item);
                    block.append(item);
                }
                else {
                    var item = inst.options.renderer.resultBlockItem;
                    item = item
                        .replace(/{x.text}/g, v.Text)
                        .replace(/{x.id}/g, v.ID)
                        .replace(/{x.icon}/g, v.Icon) //"icon-location") //
                        .replace(/{x.cityCode}/g, v.CityCode)
                        .replace(/{x.value}/g, v.Value)
                        .replace(/{x.shortDesc}/g, v.ShortDescription ? v.ShortDescription.replace(/"/g, "'") : "")
                        .replace(/{x.longDesc}/g, v.LongDescription ? v.LongDescription.replace(/"/g, "'") : "")
                        .replace(/{x.comma}/g,
                            plugin._notEmpty(v.ShortDescription) ? (v.IsPersian ? "، " : ", ") : ""
                        )
                        .replace(/\(\)/g, '');

                    item = $(item);
                    item.on("click",
                        function () {
                            plugin._saveState(elem, inst, $(this));
                            plugin.hide(elem, false);
                        });

                    block.append(item);
                }

            });
        },

        _generateContent: function (elem, inst) {
            var plugin = this;
            var picker = this._prepare(inst.options.renderer.picker
                .replace(/{x.pickerClass}/g, inst.options.pickerClass
                ), inst); //$("<div class='picker'></div>")

            var content = '';
            content += inst.options.renderer.inputBlock
                .replace(/{x.placeholder}/g, inst.options.inputPlaceHolder);

            content += inst.options.renderer.emptyBlock.replace(/{x.pickerEmptyTitle}/g, inst.options.emptyTitle);

            picker = picker.replace('{content}', content);
            picker = plugin._parseCommands(picker, inst);
            picker
                .find("input[type=text]")
                .val(inst.options.defaultValueText)
                .on('input', function () {
                    var textpart = $(this).val().trim();
                    plugin._callAjaxGetSource(elem, textpart);
                    //               window.searchboxLock = "0";
                    //if (window.searchboxTimer != null) {
                    //	clearTimeout(window.searchboxTimer);
                    //               }
                    //               window.searchboxTimer = setTimeout(function () {
                    //	if (window.searchboxLock != null) {
                    //		plugin._callAjaxGetSource(elem, textpart);
                    //                       window.searchboxLock = null;
                    //                   }
                    //               }, 180);
                })
                .on("keydown", function (e) {
                    if (e.keyCode != 9 && e.keyCode != 13) {
                        if (e.keyCode == 38) {
                            e.stopPropagation();
                            e.preventDefault();

                            if (inst.options.currentItem > 0) {
                                inst.options.currentItem--;
                            }
                            else {
                                inst.options.currentItem = inst.options.maxItem - 1;
                            }

                            plugin._selectByIndex(elem, picker);
                            return false;
                        }
                        if (e.keyCode == 40) {
                            e.stopPropagation();
                            e.preventDefault();
                            if (inst.options.currentItem < inst.options.maxItem - 1) {
                                inst.options.currentItem++;
                            }
                            else {
                                inst.options.currentItem = 0;
                            }

                            plugin._selectByIndex(elem, picker);
                            return false;
                        }
                    }
                    if (e.keyCode == 13) {
                        e.stopPropagation();
                        e.preventDefault();

                        if (inst.options.currentItem === -1) {
                            plugin.hide(elem, false);
                            plugin.search(elem);
                        } else {
                            var selectedItem = $(picker.find(".searchbox-item").get(inst.options.currentItem));
                            plugin._saveState(elem, inst, selectedItem);
                            plugin.hide(elem, false);
                        }
                        return false;
                    }
                });


            if (inst.options.isRTL) {
                picker.addClass(inst.options.renderer.rtlClass);
            }

            if ($.isFunction(inst.options.onShow)) {
                inst.options.onShow.apply(elem, [picker, inst]);
            }

            return picker;
        },

        _selectByIndex(elem, picker) {
            var plugin = this;
            var inst = this._getInst(elem);
            picker.find(".searchbox-item").removeClass(inst.options.selectedClass);
            inst.options.selectedItem = null;
            if (inst.options.currentItem > -1) {
                var selectedItem = $(picker.find(".searchbox-item").get(inst.options.currentItem));
                selectedItem.addClass(inst.options.selectedClass);
                inst.options.selectedItem = selectedItem;
            }
        },

        _parseCommands(picker, inst) {
            var addCommand = function (type, open, close, name, classes) {
                if (picker.indexOf('{' + type + ':' + name + '}') === -1) {
                    return;
                }
                var command = inst.options.commands[name];
                var date = (inst.options.commandsAsDateFormat ? command.date.apply(elem, [inst]) : null);
                picker = picker.replace(new RegExp('\\{' + type + ':' + name + '\\}', 'g'),
                    '<' + open + (command.status ? ' title="' + inst.options[command.status] + '"' : '') +
                    ' class="' + inst.options.renderer.commandClass + ' ' +
                    inst.options.renderer.commandClass + '-' + name + ' ' + classes +
                    (command.enabled(inst) ? '' : ' ' + inst.options.renderer.disabledClass) + '">' +
                    (date ? date.formatDate(inst.options[command.text], { localNumbers: inst.options.localNumbers }) :
                        inst.options[command.text]) + '</' + close + '>');
            };

            for (var name in inst.options.commands) {
                if (inst.options.commands.hasOwnProperty(name)) {
                    addCommand('button', 'button type="button"', 'button', name,
                        inst.options.renderer.commandButtonClass);
                    addCommand('link', 'a href="javascript:void(0)"', 'a', name,
                        inst.options.renderer.commandLinkClass);
                }
            }
            picker = $(picker);
            picker.find('.' + inst.options.renderer.commandClass).click(function () {
                if (!$(this).hasClass(inst.options.renderer.disabledClass)) {
                    var action = this.className.replace(
                        new RegExp('^.*' + inst.options.renderer.commandClass + '-([^ ]+).*$'),
                        '$1');
                    plugin.performAction(inst.elem, action, $(this));
                }
            })
                .end();

            return picker;
        },

        _prepare: function (text, inst) {
            var replaceSection = function (type, retain) {
                while (true) {
                    var start = text.indexOf('{' + type + ':start}');
                    if (start === -1) {
                        return;
                    }
                    var end = text.substring(start).indexOf('{' + type + ':end}');
                    if (end > -1) {
                        text = text.substring(0, start) +
                            (retain ? text.substr(start + type.length + 8, end - type.length - 8) : '') +
                            text.substring(start + end + type.length + 6);
                    }
                }
            };
            replaceSection('inline', inst.inline);
            replaceSection('popup', !inst.inline);
            var pattern = /\{l10n:([^\}]+)\}/;
            var matches = pattern.exec(text);
            while (matches) {
                text = text.replace(matches[0], inst.options[matches[1]]);
                matches = pattern.exec(text);
            }
            return text;
        },

        _checkExternalClick: function (event) {
            if (!plugin.curInst) {
                return;
            }
            var elem = $(event.target);
            if (elem.closest('.' + plugin._popupClass + ',.' + plugin._triggerClass).length === 0
                && !elem.hasClass(plugin._getMarker())) {
                if (!plugin.curInst.options.manualClose) {
                    plugin.hide(plugin.curInst)
                };
            }
        },

        hide: function (elem, immediate) {
            $('body').css('overflow-y', 'auto')
            if (!elem) {
                return;
            }
            var inst = this._getInst(elem);
            if ($.isEmptyObject(inst)) {
                inst = elem;
            }
            if (inst && inst === plugin.curInst) {
                // if (!inst.options.manualClose)
                // {
                inst.div.find(".searchbox-item").filter("." + inst.options.selectedClass);
                //this._saveState(elem, inst, item);
                //}
                var showAnim = (immediate ? '' : inst.options.showAnim);
                var showSpeed = inst.options.showSpeed;
                showSpeed = (showSpeed === 'normal' && $.ui &&
                    parseInt($.ui.version.substring(2)) >= 8 ? '_default' : showSpeed);
                var postProcess = function () {
                    if (!inst.div) {
                        return;
                    }
                    inst.div.remove();
                    inst.div = null;
                    plugin.curInst = null;

                    if ($.isFunction(inst.options.onClose)) {
                        inst.options.onClose.apply(elem, [inst]);
                    }
                };
                inst.div.stop();
                if ($.effects && ($.effects[showAnim] || ($.effects.effect && $.effects.effect[showAnim]))) {
                    inst.div.hide(showAnim, inst.options.showOptions, showSpeed, postProcess);
                }
                else {
                    var hideAnim = (showAnim === 'slideDown' ? 'slideUp' : (showAnim === 'fadeIn' ? 'fadeOut' : 'show'));
                    inst.div[hideAnim]((showAnim ? showSpeed : ''), postProcess);
                }
                if (!showAnim) {
                    postProcess();
                }
            }

        },

        _keyDown: function (event) {
            var elem = (event.data && event.data.elem) || event.target;
            var inst = plugin._getInst(elem);
            var handled = false;
            var command;
            if (inst.inline || inst.div) {
                if (event.keyCode === 9) { // Tab - close
                    plugin.hide(elem);
                }
                else if (event.keyCode === 13) { // Enter - select
                    plugin.selectDate(elem,
                        $('a.' + inst.options.renderer.highlightedClass, inst.div)[0]);
                    handled = true;
                }
                else { // Command keystrokes
                    var commands = inst.options.commands;
                    for (var name in commands) {
                        if (inst.options.commands.hasOwnProperty(name)) {
                            command = commands[name];
                            /* jshint -W018 */ // Dislikes !!
                            if (command.keystroke.keyCode === event.keyCode &&
                                !!command.keystroke.ctrlKey === !!(event.ctrlKey || event.metaKey) &&
                                !!command.keystroke.altKey === event.altKey &&
                                !!command.keystroke.shiftKey === event.shiftKey) {
                                /* jshint +W018 */
                                plugin.performAction(elem, name);
                                handled = true;
                                break;
                            }
                        }
                    }
                }
            }
            else { // Show on 'current' keystroke
                command = inst.options.commands.current;
                /* jshint -W018 */ // Dislikes !!
                if (command.keystroke.keyCode === event.keyCode &&
                    !!command.keystroke.ctrlKey === !!(event.ctrlKey || event.metaKey) &&
                    !!command.keystroke.altKey === event.altKey &&
                    !!command.keystroke.shiftKey === event.shiftKey) {
                    /* jshint +W018 */
                    plugin.show(elem);
                    handled = true;
                }
            }
            inst.ctrlKey = ((event.keyCode < 48 && event.keyCode !== 32) || event.ctrlKey || event.metaKey);
            if (handled) {
                event.preventDefault();
                event.stopPropagation();
            }
            return !handled;
        },

        _keyPress: function (event) {
            // var inst = plugin._getInst((event.data && event.data.elem) || event.target);
            // if (!$.isEmptyObject(inst) && inst.options.constrainInput) {
            // 	var ch = String.fromCharCode(event.keyCode || event.charCode);
            // 	var allowedChars = plugin._allowedChars(inst);
            // 	return (event.metaKey || inst.ctrlKey || ch < ' ' ||
            // 		!allowedChars || allowedChars.indexOf(ch) > -1);
            // }
            return true;
        },

        _allowedChars: function (inst) {
            return allowedChars;
        },

        _keyUp: function (event) {
            var elem = (event.data && event.data.elem) || event.target;
            var inst = plugin._getInst(elem);
            if (!$.isEmptyObject(inst) && !inst.ctrlKey && inst.lastVal !== inst.elem.val()) {
                try {

                }
                catch (e) {
                    // Ignore
                }
            }
            return true;
        },

        _doMouseWheel: function (event, delta) {
            event.preventDefault();
        },

        clear: function (elem) {
            var inst = this._getInst(elem);
            if (!$.isEmptyObject(inst)) {
                var hidden = inst.div.find("input[type=hidden]");
                var input = inst.div.find("input[type=text]");
                hidden.val("");
                input.val("").focus();
                this._updateInput(elem);

                if ($.isFunction(inst.options.onClear)) {
                    inst.options.onClear.apply(elem, [inst]);
                }

                plugin._callAjaxGetSource(elem, plugin._getInput(elem).val());
                //}
                plugin._getInput(elem).focus();
            }
        },

        search: function (elem) {
            var inst = this._getInst(elem);
            if (!$.isEmptyObject(inst)) {
                //var hidden = inst.div.find("input[type=hidden]");
                var input = inst.div.find("input[type=text]");
                var value = input.val();

                window.location.href = inst.options.searchPage.replace(/{search}/g, value);
            }
        },

        isSelectable: function (elem, date) {
            return true;
        },

        _isSelectable: function (elem, date, onDate, minDate, maxDate) {
            return true;
        },

        performAction: function (elem, action, obj) {
            var inst = this._getInst(elem);
            if (!$.isEmptyObject(inst) && !this.isDisabled(elem)) {
                var commands = inst.options.commands;
                if (commands[action] && commands[action].enabled.apply(elem, [inst, obj])) {
                    commands[action].action.apply(elem, [inst, obj]);
                }
            }
        },

        _applyTitle: function (obj, value) {
            var label = obj.find('.sublevel-title');
            if (label.length > 0) {
                var text = label.data("title")
                    .replace(/{xx.value-1}/g, value - 1)
                    .replace(/{xx.value}/g, value)
                    .replace(/{xx.value\+1}/g, value + 1);
                label.html(text);
            }

            return obj;
        }
    });

    var plugin = $.searchboxPicker; // Singleton instance

    $(function () {
        $(document).on('mousedown.' + pluginName, plugin._checkExternalClick).
            on('resize.' + pluginName, function () { plugin.hide(plugin.curInst); });
    });
})(jQuery);